import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Link } from "react-router-dom";

// MUI imports
import {
  Box,
  Container,
  Divider,
  Stepper,
  Step,
  StepLabel,
  Typography,
  IconButton,
} from "@mui/material";

// Project Imports
import Page from "../../Components/Dashboard/Page";
import PartOne from "./PartOne";
import PartTwo from "./PartTwo";
import PartThree from "./PartThree";
import FormCompletionSuccess from "./FormCompletionSuccess";
import { paFetchTrainerById } from "../../Actions";
import Iconify from "../Dashboard/Iconify.js";

const steps = [
  {
    icon: "Hello",
    title: "Part One",
    subTitle: "Sections 1 - 3",
  },
  {
    icon: "Hello",
    title: "Part Two",
    subTitle: "Sections 4 - 5",
  },
  {
    icon: "Hello",
    title: "Part Three",
    subTitle: "Sections 6 - 8",
  },
];

const DisplayCurrentFormSection = ({ currentStep }) => {
  switch (currentStep) {
    case 0:
      return <PartOne />;

    case 1:
      return <PartTwo />;

    case 2:
      return <PartThree />;

    case 3:
      return <FormCompletionSuccess />;

    default:
      break;
  }
};

const PhysicalApprovalForm = () => {
  const globalDispatch = useDispatch();

  const tregPhysicalApprovalReducer = (globalState) =>
    globalState.tregPhysicalApprovalReducer;

  const { paCurrentFormStep, currentTrainingCenterId } = useSelector(
    tregPhysicalApprovalReducer
  );

  useEffect(() => {
    if (Number.isInteger(currentTrainingCenterId)) {
      globalDispatch(paFetchTrainerById(currentTrainingCenterId));
    }
  }, []);

  return (
    <Box sx={{ width: "100%" }}>
      <Page title="Physical Approval">
        <Page>
          <Container maxWidth="xl">
            <Box sx={{ pb: 2, display: "flex" }}>
              <Link to="/home/trainersmanagement/physicalApproval">
                <IconButton>
                  <Iconify icon="ic:round-keyboard-arrow-left" />
                </IconButton>
              </Link>
              <Typography
                variant="h5"
                style={{ fontWeight: 600, color: "#212B36" }}
              >
                Physical Approval Form
              </Typography>
            </Box>

            {/* stepper component  */}
            <Stepper activeStep={paCurrentFormStep}>
              {steps.map((stepInfo) => {
                return (
                  <Step key={stepInfo.title}>
                    <StepLabel> {stepInfo.title} </StepLabel>
                  </Step>
                );
              })}
            </Stepper>

            {/* horizontal line  */}
            <Box sx={{ m: "48px 0 " }}>
              <Divider />
            </Box>

            {/* Form Page Content */}
            <DisplayCurrentFormSection currentStep={paCurrentFormStep} />
          </Container>
        </Page>
      </Page>
    </Box>
  );
};

export default PhysicalApprovalForm;
